// ReconciliationVersionsPanel — wrapper over the shared VersioningPanel.
//
// Powers the Financial Immutability layer for bank reconciliations:
// every match attempt or adjustment is appended as a draft and only
// becomes the live reconciliation after explicit posting.
import React from 'react';
import VersioningPanel from './versioning/VersioningPanel';

const RECON_CONFIG = {
  endpointBase: '/bank-reconciliations',
  idField: 'id',
  numberKey: 'reconciliation_no',
  entityLabel: 'التسوية البنكية',
  actionAmend: 'reconciliation.match',
  actionAmendPost: 'reconciliation.match.post',
  testIdPrefix: 'rec',
  accentClass: 'bg-teal-600 hover:bg-teal-700',
  amendableFields: [
    { key: 'notes',             label: 'ملاحظات',                 type: 'textarea' },
    { key: 'book_balance',      label: 'رصيد الدفاتر',            type: 'number' },
    { key: 'statement_balance', label: 'رصيد كشف الحساب',         type: 'number' },
    { key: 'difference',        label: 'الفرق',                    type: 'number' },
    { key: 'status',            label: 'الحالة (pending/completed)', type: 'text' },
  ],
  financialFields: new Set([
    'book_balance', 'statement_balance', 'difference',
  ]),
  headlineFieldOrder: ['difference', 'book_balance', 'statement_balance'],
};

export default function ReconciliationVersionsPanel({ reconciliation, onUpdated }) {
  return (
    <VersioningPanel
      entity={reconciliation}
      config={RECON_CONFIG}
      onUpdated={(data) => onUpdated && onUpdated(data?.reconciliation || data)}
    />
  );
}
